import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dashboard-header" }
const _hoisted_2 = { class: "title-main" }
const _hoisted_3 = { class: "default-form" }
const _hoisted_4 = { class: "input-row" }
const _hoisted_5 = {
  key: 0,
  class: "input-wr"
}
const _hoisted_6 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_7 = { class: "input-wr" }
const _hoisted_8 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_9 = { class: "input-wr" }
const _hoisted_10 = {
  key: 0,
  class: "error-hint"
}
const _hoisted_11 = { class: "input-row" }
const _hoisted_12 = { class: "input-wr" }
const _hoisted_13 = { class: "input-row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("h2", _hoisted_2, _toDisplayString($setup.getFirstLastName($setup.user)), 1)
    ]),
    _createElementVNode("form", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        ($setup.roleByRoute !== $setup.UserRoles.LAWYER)
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "label" }, "ABN / ACN", -1)),
              _withDirectives(_createElementVNode("input", {
                class: _normalizeClass(["input", { error: $setup.v$.abnAcn?.$error }]),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.form.abnAcn) = $event)),
                type: "text",
                placeholder: "ABN / ACN"
              }, null, 2), [
                [_vModelText, $setup.form.abnAcn]
              ]),
              ($setup.v$.abnAcn?.$error)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString($setup.v$.abnAcn.$errors[0].$message), 1))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_7, [
          _cache[5] || (_cache[5] = _createElementVNode("label", { class: "label" }, "Company Name", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.companyName.$error }]),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.form.companyName) = $event)),
            type: "text",
            placeholder: "Company Name"
          }, null, 2), [
            [_vModelText, $setup.form.companyName]
          ]),
          ($setup.v$.companyName.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString($setup.v$.companyName.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, [
          _cache[6] || (_cache[6] = _createElementVNode("label", { class: "label" }, "Company Address", -1)),
          _withDirectives(_createElementVNode("input", {
            class: _normalizeClass(["input", { error: $setup.v$.companyAddress?.$error }]),
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.form.companyAddress) = $event)),
            type: "text",
            placeholder: "Company Address"
          }, null, 2), [
            [_vModelText, $setup.form.companyAddress]
          ]),
          ($setup.v$.companyAddress?.$error)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString($setup.v$.companyAddress.$errors[0].$message), 1))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _cache[7] || (_cache[7] = _createElementVNode("label", { class: "label" }, "Chargebee Customer_id", -1)),
          _withDirectives(_createElementVNode("input", {
            class: "input",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.form.chargebeeCustomerId) = $event)),
            type: "text",
            placeholder: "Customer_id"
          }, null, 512), [
            [_vModelText, $setup.form.chargebeeCustomerId]
          ])
        ]),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "input-wr" }, null, -1)),
        _cache[9] || (_cache[9] = _createElementVNode("div", { class: "input-wr" }, null, -1))
      ]),
      _createElementVNode("div", _hoisted_13, [
        _createVNode(_component_router_link, {
          class: "button default outlined cancel-btn",
          to: { name: $setup.roleByRoute === $setup.UserRoles.LAWYER ? 'AdminLawyer' : 'AdminUser', params: { userId: $setup.userId } }
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("Cancel", -1)
          ]))]),
          _: 1
        }, 8, ["to"]),
        _createElementVNode("button", {
          class: "button default primary create-btn",
          onClick: $setup.updateUser,
          type: "button"
        }, "Update")
      ])
    ])
  ], 64))
}